import {
  MOMENTS_URL,
  MOMENT_URL,
  SEARCH_MOMENTS_URL,
  TOGGLE_PREMIUM_MOMENT_URL,
  MOMENT_UPLOAD_URL,
  MOMENT_FILE_URL
} from 'app/utils/Constants';

import {
  get,
  post,
  put,
  destroy,
  patch
} from 'app/services/ApiService';

export const getMoments = async params => {
  return await post(SEARCH_MOMENTS_URL(), params);
}

export const createMoment = async params => {
  return await post(MOMENTS_URL(), params);
}

export const updateMoment = async (id, params) => {
  params.portal = true;
  return await put(MOMENT_URL(id), params);
}

export const destroyMoment = async id => {
  return await destroy(MOMENT_URL(id));
}

export const destroyMoments = async ids => {
  return await patch(MOMENTS_URL(), { ids });
}

export const createMomentFile = async params => {
  return await post(MOMENT_FILE_URL(), params);
}

export const getMomentUploadUrl = async (id, fileType) => {
  return await get(MOMENT_UPLOAD_URL(id, fileType, true));
}

export const togglePremiumMoment = async (id, params) => {
  return await put(TOGGLE_PREMIUM_MOMENT_URL(id), params);
}
